import { Types } from './types'

const initialState = {
    dataAgencyBonus: [],
    notify: {
        rows: [],
        paging: {}
    },
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_BONUS:
            return {
                ...newState,
                dataAgencyBonus: [...action.payload]
            }
        case Types.SAVE_LIST_NOTIFY:
        return {
            ...newState,
            notify: {...action.payload}
        }
        default:
            return { ...newState }
    }
}
export default reducer
